import React from 'react'

export default function DigitalMarketing() {
  return (
    <div className="bg-gray-100 min-h-screen flex flex-col items-center justify-center p-5">
      <div className="bg-gradient-to-r from-indigo-400 to-blue-500 rounded-3xl shadow-2xl p-10 text-center transform hover:scale-105 transition-transform duration-300 ease-in-out">
        <h1 className="text-5xl font-extrabold text-white mb-4 text-shadow-lg">Welcome to Digital Marketing</h1>
        <p className="text-lg text-gray-100 mb-8 max-w-lg">
          We are a professional design agency focusing on building functional, simple, and human-centered digital products for the future.
        </p>
        <button className="bg-white text-blue-500 font-bold px-8 py-4 rounded-full shadow-lg hover:bg-gray-200 transform hover:scale-110 transition-all duration-300">
          Learn More
        </button>
      </div>
    </div>
  )
}
